/**
 * React Query hook for the authenticated user's tanks list.
 *
 * Persisted (meta.persist) so the tank selector and everything downstream
 * of tank selection hydrates instantly on reload. While auth is still
 * resolving the query is disabled, but hydrated data is already readable
 * from the cache — consumers render last-known tanks immediately and the
 * list revalidates once auth completes.
 */
import { useQuery } from '@tanstack/react-query';
import { getTanks, tanksQueryKey } from '@/api/tanks';
import { useAuth } from '@/contexts/AuthContext';
import { CACHE_TIMES } from '@/config/cacheTimes';

export function useTanks() {
  const { isAuthenticated } = useAuth();

  return useQuery({
    queryKey: tanksQueryKey,
    queryFn: getTanks,
    enabled: isAuthenticated,
    staleTime: CACHE_TIMES.DATA,
    meta: { persist: true },
  });
}
